import { Nullable } from 'lib_ts/interfaces/common/i-generics';
import { IBurnInTest } from 'lib_ts/interfaces/i-burn-in-test';
import { create } from 'zustand';

type State = {
  tests: IBurnInTest[];
  activeTestID: Nullable<string>;
};

type Actions = {
  // whenever hitting r2f in range test or getting shots in firing test
  updateTest: (value: IBurnInTest) => void;
  // after mounting the burn-in component
  reset: () => void;
};

type BurnInTestStore = State & Actions;

const useBurnInTestStore = create<BurnInTestStore>((set) => ({
  tests: [],
  activeTestID: null,
  firingPitches: [],

  updateTest: (value) => {
    set((state) => ({
      tests: state.tests.map((m) => (m._id === value._id ? value : m)),
    }));
  },
  reset: () => {
    set({
      tests: [],
      activeTestID: null,
    });
  },
}));

export default useBurnInTestStore;
